<template>
  <div class="popup-container">
    <div class="popup-content enable-scroll">
      <div v-if="consent !== '' && confirmation !== ''">
        <div v-html="consent"></div>
        <div class="confirmation" @click="selectCheckBox">
          <div><input type="checkbox" v-model="isChecked"></div>
          &nbsp;<div v-html="confirmation"></div>
        </div>
        <div class="confirm-button">
          <ion-button class="button" :disabled="!isChecked" @click="closeModal">確認</ion-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { IonButton } from "@ionic/vue";
// import '../../theme/consentReset.scss';

export default {
  name: "TermsModal",
  components: {
    IonButton
  },
  props: {
    consent: { type: String, default: '' },
    confirmation: { type: String, default: '' },
  },
  data() {
    return {
      isChecked: false
    }
  },
  methods: {
    selectCheckBox() {
      this.isChecked = !this.isChecked;
    },
    closeModal() {
      document.querySelector('.popup-container').style.display = 'none';
    },
  },
};
</script>

<style scoped lang="scss">
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: block;
}

.popup-content {
  position: absolute;
  overflow-y: scroll;
  top: 50%;
  left: 50%;
  width: 80%;
  height: 87%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 23px;
  border-radius: 10px;
}

.confirmation {
  display: flex;
  align-items: start;
}

.confirm-button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 20px 0;
}

.button {
  --background: #94c43b;
  width: var(--ecs-control-width-sm);
  max-width: 90vw;
  min-height: var(--ecs-button-min-height);
  height: auto;
  --padding-top: clamp(0.5rem, 1.4vw, 0.875rem);
  --padding-bottom: clamp(0.5rem, 1.4vw, 0.875rem);
  white-space: normal;
  font-size: var(--ecs-font-md);
}

:deep() {
  @import '../../theme/consentReset.scss';
}
</style>
